import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerColumns = [
    {
      title: '分类导航',
      links: [
        { label: '热血战斗', path: '/category/hot-blooded-battle' },
        { label: '恋爱校园', path: '/category/romance-school' },
        { label: '奇幻冒险', path: '/category/fantasy-adventure' },
        { label: '恋爱宫廷', path: '/category/romance-palace' },
      ]
    },
    {
      title: '热门推荐',
      links: [
        { label: '热门漫画', path: '/?tab=hot' },
        { label: '最新上架', path: '/?tab=new' },
        { label: '完结漫画', path: '/?tab=completed' },
        { label: '精选推荐', path: '/?tab=featured' },
      ]
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', path: '/about' },
        { label: '商务合作', path: '/about#cooperation' },
        { label: '联系方式', path: '/about#contact' },
        { label: '常见问题', path: '/about#faq' },
      ]
    },
    {
      title: '关注我们',
      links: [
        { label: '微信公众号', path: '#' },
        { label: '新浪微博', path: '#' },
        { label: '哔哩哔哩', path: '#' },
        { label: '小红书', path: '#' },
      ]
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        {/* Top Navigation Columns */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-14">
          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4 relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-6 after:h-0.5 after:bg-primary-500">
                {column.title}
              </h4>
              <ul className="space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    {link.path.startsWith('/') ? (
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                        rel="nofollow"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Brand Area */}
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between pt-8 border-t border-background-200/50 gap-6">
          <div className="flex flex-col gap-2">
            <div className="flex items-baseline gap-1">
              <span className="font-heading text-4xl font-black text-foreground-950 tracking-tight">韩漫</span>
              <span className="font-heading text-4xl font-black text-primary-500 tracking-tight">大全</span>
            </div>
            <p className="text-xs text-foreground-500">汇聚优质韩国漫画，畅享免费阅读体验</p>
          </div>
          <div className="flex flex-col sm:items-end gap-3">
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-primary-100 text-foreground-500 hover:text-primary-600 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-primary-100 text-foreground-500 hover:text-primary-600 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-primary-100 text-foreground-500 hover:text-primary-600 transition-colors" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-primary-100 text-foreground-500 hover:text-primary-600 transition-colors" aria-label="小红书" rel="nofollow">
                <i className="ri-reddit-line"></i>
              </a>
            </div>
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 韩漫大全. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}